<template>
  <div>
    <span class="title">{{ title }}</span>
    <div class="list-wrapper">
      <ul>
        <li v-for="(value, index) in ranking" :key="index">
          {{ index + 1 }}. {{ value[labelAttribute] }}
          <span :style="{color: color}">{{ value[valueAttribute] }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RankingIndicator',
  props: {
    title: {
      type: String,
      required: true
    },
    ranking: {
      type: Array,
      required: true
    },
    labelAttribute: {
      type: String,
      required: true
    },
    valueAttribute: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'black'
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  color: $primary-color;
  font-size: 20px;
  text-transform:inherit;
}

.list-wrapper {
  display: flex;
  justify-content: center;
  ul {
    margin: auto;
    list-style-type: none;
    text-align: left;
    margin: 0;
    padding: 20px;
  }
}
</style>
